import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import createPaginationControl from "../../Common/createPaginationControl";
import Excel from "../../Common/Excel";
import PrintOut from "../../Common/PrintOut";
import Spinner from "../../Common/Spinner";
import FilterContainer from "./FilterContainer";
import List from "./List";

import { setSort as setSortAction } from "../../../actions/advancedListActions";
import { getMiljogebyrer as getMiljogebyrerAction } from "../../../actions/miljogebyrerActions";

import { getMiljogebyrInExcelFormat } from "../../../selectors/miljogebyrerSelector";

import { authorized } from "../../../utils/authorizationUtils";

import { juridiskAll } from "../../../constants/roles";
import sitePaths from "../../../constants/sitePaths";
import * as title from "../../../constants/titles";

const PaginationControl = createPaginationControl("miljogebyrer", {
  apiCallAction: getMiljogebyrerAction,
  queriesForApiReducerName: "forms.miljogebyrerOversiktFilterForm",
});

export default function OversiktContainer() {
  const [waitingForGetMiljogebyrer] = useState(false);
  const dispatch = useDispatch();

  const miljogebyrer = useSelector((state) => state.miljogebyrer);
  const miljogebyrerOversiktFilterForm = useSelector(
    (state) => state.forms.miljogebyrerOversiktFilterForm
  );
  const overtredelseskoderMiljogebyr = useSelector(
    (state) => state.overtredelseskoderMiljogebyr
  );
  const miljogebyrInExcelFormat = useSelector(getMiljogebyrInExcelFormat);

  const getMiljogebyrer = (miljogebyrOversiktFilterForm, page, count, sort) =>
    dispatch(getMiljogebyrerAction(miljogebyrOversiktFilterForm, page, count, sort));
  const setSort = (sort) => dispatch(setSortAction("MILJOGEBYRER", sort));

  useEffect(() => {
    document.title = title.miljogebyr.miljogebyroversikt;
  }, []);

  return (
    <>
      <FilterContainer />
      <div style={{ height: 28 }} />
      {(!waitingForGetMiljogebyrer || miljogebyrer.items !== 0) && (
        <React.Fragment>
          <div>
            <div className="pull-left" style={{ paddingLeft: 50 }}>
              {!authorized(juridiskAll) && (
                <div style={{ display: "inline-block", marginRight: 10 }}>
                  <PrintOut
                    url={`${window.location.origin}${sitePaths.miljogebyrer.oversikt.utskrift}`}
                    dataToStoreInSessionStorage={{
                      queryData: {
                        ...miljogebyrerOversiktFilterForm,
                      },
                      paginationData: {
                        page: miljogebyrer.page,
                        count: miljogebyrer.count,
                      },
                    }}
                  />
                </div>
              )}
              <Excel
                element={(onClick) => (
                  <button
                    className="btn btn-bym-medium btn-bym-action"
                    onClick={onClick}
                  >
                    Lag rapport
                  </button>
                )}
                filename="Miljøgebyr.xlsx"
                sheets={miljogebyrInExcelFormat}
                total={miljogebyrer.total}
                count={miljogebyrer.count}
              />
            </div>
            <div
              className="pull-right ileggelse-list-page-total-ileggelser"
              style={{ paddingTop: 20, paddingRight: 50 }}
            >
              {miljogebyrer.total} miljøgebyr
            </div>
          </div>
          <div className="clearfix" />
          <div style={{ height: 22 }} />
          <div style={{ paddingRight: 50, paddingLeft: 50 }}>
            <div className="ileggelse-list-page-content-container">
              <List
                miljøgebyrer={miljogebyrer.items}
                overtredelseskoderMiljogebyr={overtredelseskoderMiljogebyr}
                sort={miljogebyrer.sort}
                setSort={setSort}
                page={miljogebyrer.page}
                count={miljogebyrer.count}
                miljogebyrerOversiktFilterForm={miljogebyrerOversiktFilterForm}
                getMiljogebyrer={getMiljogebyrer}
              />
            </div>
            <PaginationControl storeKey="miljøgebyrer" />
          </div>
        </React.Fragment>
      )}
      <Spinner
        isLoading={
          waitingForGetMiljogebyrer && miljogebyrer.items.length === 0
        }
      />
      <div style={{ height: 50 }} />
    </>
  );
}
